module.exports = __webpack_public_path__ + "static/media/Subscription_Business.c8c8b9de.png";